import React from 'react';

import win from '../../../../r/shared/win';
import { FootnoteWrapper } from './styled';
import Button from '../button';

const { isLoggedIn } = win;

const Footnote = () => (
  <FootnoteWrapper>
    <h1>Create full-featured forms and surveys in minutes</h1>
    <p>Get access to all Formplus features</p>
    <Button
      href={!isLoggedIn ? '/auth?utm_source=website&utm_medium=features-page' : '/r'}
      text={!isLoggedIn ? 'Try it for Free' : 'Access Dashboard'}
      className="success shadow"
      size="large"
    />
  </FootnoteWrapper>
);

export default Footnote;